import { ThemeUICSSObject, focusOutline } from '@apia/theme';
/* IMPORT HERE */

const primary: ThemeUICSSObject = {
  alignItems: 'center',
  display: 'flex',
  width: '100%',

  '& > button': {
    flexShrink: 0,
  },

  '.tabs__list, .tabsList__fixedTabs': {
    display: 'flex',
    flexDirection: 'row',
    overflow: 'auto',
    height: '100%',
  },

  '.tabs__list': {
    width: '100%',
  },

  '&.vertical': {
    flexDirection: 'column',
  },

  '.tabs__item__wrapper': (theme) => {
    return {
      flexShrink: 0,
      display: 'flex',

      '&:focus-within': {
        ...focusOutline,
        outlineColor: 'outlineColor',
      },

      '*:focus': {
        outlineStyle: 'none ',
      },

      '.tabs__item__close': {
        backgroundColor: 'transparent',
        color: 'inherit',

        ...theme.palette.getStatesFromPath('buttons.outlineDanger', {
          states: { default: false, path: false },
        }),
      },

      ...theme.palette.getStatesFromDefinition(
        {
          backgroundColor: theme.palette.primary.main,
          color: 'white',
        },
        { states: { selected: false } },
      ),

      '&.open': {
        zIndex: 1,

        ...theme.palette.getStatesFromDefinition(
          {
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.primary,
          },
          {
            states: { selected: false },
            mergeObject: {
              '&:focus-within': {
                backgroundColor: theme.palette.background.paper,
              },
            },
          },
        ),
      },
      '.button__content': {
        alignItems: 'center',
        display: 'flex',
        '.tabs__item__button': {
          background: 'transparent ',
          color: 'inherit ',
          paddingY: '0px',
          '&:focus, &:hover, &:active': {
            background: 'transparent ',
            color: 'inherit ',
          },
        },
      },
    };
  },

  '.tabsList__fixedTabs': {
    flexShrink: 0,
  },

  '.tabs__item__button': {
    background: 'transparent ',
    color: 'inherit ',

    '&:focus, &:hover, &:active': {
      background: 'transparent ',
      color: 'inherit ',
    },
  },

  content: {
    '.tabs__content': {
      position: 'fixed',
      top: '32px',
      bottom: 0,
      left: 0,
      right: 0,
      overflow: 'hidden',
      zIndex: 0,

      '.tabs__content__spinner__wrapper': {
        background: 'palette.background.default',
        alignItems: 'center',
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        left: 0,
        overflow: 'hidden',
        position: 'absolute',
        right: 0,
        top: 0,
        zIndex: 0,
      },

      iframe: {
        border: 'none',
        display: 'none',
        height: '100%',
        width: '100%',
      },

      '&.open': {
        zIndex: 1,
      },

      '&.open iframe': {
        display: 'block',
      },
    },
  },
};

export default primary;
